import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SysAdminService } from "../../../services/sysadmin.service";
import { UserModifyAddSchoolComponent } from "./user-modify-add-school/user-modify-add-school.component";

@Component({
	selector: "caass-user-modify-schools",
	templateUrl: "./user-modify-schools.component.html",
	styleUrls: ["./user-modify-schools.component.css"],
})
export class UserModifySchoolsComponent implements OnInit {
	constructor(private dialogService: DialogService, private sysAdminService: SysAdminService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		// if(this.EditMode == true){
		//   this.loadSchool();
		// }
	}

	ngOnChanges() {
		// if(this.EditMode == true){
		//   this.loadSchool();
		// }
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() lstSchoolChanged: EventEmitter<any> = new EventEmitter();
	@Input() EditMode: any = false;
	@Input() UserID: any = -1;
	@Input() Processing: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchools: any = [];
	lstSchool: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	// loadSchool(){
	//   if(this.UserID == undefined || this.UserID <= 0){
	//     return;
	//   }

	//   this.loading = true;

	//   var result = this.sysAdminService.SysAdminUserSchoolsSelect(this.UserID);
	//   result.subscribe(
	//     response => {
	//       this.lstSchool = response;

	//       this.lstSchoolChanged.emit(this.lstSchool);

	//       this.loading = false;
	//     },
	//     error => {
	//       this.loading = false;
	//     }
	//   )

	// }

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onAdd() {
		var ref = this.dialogService.open(UserModifyAddSchoolComponent, {
			header: "Add Schools",
			width: "fit-content",
			data: {
				SelectedSchools: this.lstSchool,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0 && response != undefined) {
				var lstToAdd = response;

				for (var z = 0; z < lstToAdd.length; z++) {
					var toAdd = lstToAdd[z];

					var found = false;
					for (var i = 0; i < this.lstSchool.length; i++) {
						var next = this.lstSchool[i];

						if (toAdd.SchoolID == next.SchoolID) {
							found = true;
						}
					}

					if (!found) {
						this.lstSchool = [...this.lstSchool, toAdd];
					}
				}

				this.lstSchoolChanged.emit(this.lstSchool);
			}
		});
	}

	onRemove() {
		this.lstSchool = this.lstSchool.filter((school) => this.SelectedSchools.indexOf(school) == -1);

		this.SelectedSchools = [];

		this.lstSchoolChanged.emit(this.lstSchool);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
		// this.SelectedSchool = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";
		// this.SelectedSchool = null;
	}
	onRowDblClick(School) {
		// this.SelectedSchool = School;
		// this.onEditSchool();
	}
	////////////////////////////////////////////
}
